import axios from 'axios';

export function normalizeApiBaseUrl(value = process.env.REACT_APP_API_URL) {
  const baseUrl = value?.trim() || '/api/';
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
}

const api = axios.create({
  baseURL: normalizeApiBaseUrl(),
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export default api;
